import { createSlice } from '@reduxjs/toolkit'

export interface ScanState {
  currentScan: any | null
  loading: boolean
  error: string | null
}

const initialState: ScanState = {
  currentScan: null,
  loading: false,
  error: null,
}

const scanSlice = createSlice({
  name: 'scan',
  initialState,
  reducers: {
    setCurrentScan: (state, action) => {
      state.currentScan = action.payload
    },
    clearCurrentScan: (state) => {
      state.currentScan = null
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
  },
})

export const { setCurrentScan, clearCurrentScan, setLoading, setError } = scanSlice.actions
export default scanSlice.reducer